<div class="expansion-panel-outer" [ngStyle]="expansionPanelOuterStyle">
  <div class="expansion-panel-inner"
       [@bodyExpansion]="getExpandedState()"
       [class]="getExpandedClass()"
       [ngStyle]="innerStyle">
    <ng-container *ngFor="let item of items; index as i">
      <filter-select-item
        [form]="getItem(i)"
        [item]="item"
        [template]="itemTemplate"
        [controlType]="controlType"
        [attr.tabindex]="itemTemplate.tabindex"
        (checked)="itemChecked.emit({$event, item})"
      ></filter-select-item>
    </ng-container>
  </div>
</div>
